var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSensitive = function SvgSensitive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Sensitive Content Icon",
    fill: "#f6145a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 786",
    d: "m67.053 13.058-8.137 7.845C53.361 16.68 46.909 13.492 40 13.492c-20.675 0-37.435 28.38-37.435 28.38a86.234 86.234 0 0 0 15.433 18.465l-8.234 7.935 3.785 3.926 57.289-55.216ZM27.187 41.872a12.8 12.8 0 0 1 20.552-10.2L29.527 49.227a12.7 12.7 0 0 1-2.339-7.355Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 787",
    d: "M64.416 25.621 52.048 37.542a12.8 12.8 0 0 1-16.824 16.216L23.781 64.787c4.907 3.223 10.408 5.466 16.22 5.466 20.675 0 37.433-28.38 37.433-28.38a87.53 87.53 0 0 0-13.018-16.252Z"
  }))));
};
export default SvgSensitive;